import { render, staticRenderFns } from "./cabinet-notification-show.vue?vue&type=template&id=35edcf6c&"
import script from "./cabinet-notification-show.vue?vue&type=script&lang=js&"
export * from "./cabinet-notification-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35edcf6c')) {
      api.createRecord('35edcf6c', component.options)
    } else {
      api.reload('35edcf6c', component.options)
    }
    module.hot.accept("./cabinet-notification-show.vue?vue&type=template&id=35edcf6c&", function () {
      api.rerender('35edcf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/notifications/cabinet-notification-show.vue"
export default component.exports